import StyledTextTruncated from './StyledTextTruncated';

interface TextTruncatedProps {
  children: React.ReactNode;
  title?: string;
  width?: string;
}

const TextTruncated: React.FC<TextTruncatedProps> = ({
  children,
  title = '',
  width = '100%',
}) => {
  return (
    <StyledTextTruncated title={title} width={width}>
      {children}
    </StyledTextTruncated>
  );
};

export default TextTruncated;
